module.exports = __webpack_public_path__ + "img/avatar-s-15.jpg";